

































import { Component, Vue } from 'vue-property-decorator';
import PeriodBar from '@/components/PeriodBar.vue';
import Base from '@/views/Base';
import axios from 'axios';
import Course from '@/models/Course';
import _ from 'lodash';

@Component({
  components: {
    PeriodBar,
  },


})
export default class Home extends Base {
  private filters = { 
    text: '',
    period: 0,
    openUvA: false 
  };
  private courses: Course[] | null = null;
  private pageSize = 50;

  public created() {
    axios.get('catalog_courses.json').then((resp) => this.courses = resp.data);
    this.filters = this.$store.state.filters;
  }

  get currentPage() {
    return _.take(this.filteredCourses, this.pageSize);
  }

  saveFilters() {
    this.$store.dispatch('setFilters', this.filters);
  }

  get filteredCourses() {
    return this.courses ? 
      this.courses.filter((z) =>
        (z.Title.toLowerCase().indexOf(this.filters.text.toLowerCase()) !== -1
          || z.Code.toLowerCase().indexOf(this.filters.text.toLowerCase()) !== -1)
          && (this.filters.period === 0 || _.some(z.Periods, (p) => p.length > 0 && p[0] === this.filters.period))
          && (!this.filters.openUvA || z.OpenUvA)
          && (this.$route.params.lang != 'en' || z.Language != 'nl')
      ) : null;
  }

  showAll() {
    this.pageSize = 5000;
  }
}
